// extracted by mini-css-extract-plugin
export default {"MainLayout":"MainLayout_MainLayout__kFn04"};